import { Container } from "./container";
function Injectable(lazy) {
    if (lazy === void 0) { lazy = null; }
    return function (target) {
        Container.register(target);
    };
}
export { Injectable, };
//# sourceMappingURL=injectable.js.map